import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectorChipsComponent } from './selector-chips.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SelectorModule } from '../selector.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    SelectorChipsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    SelectorModule,
    TranslateModule,
    MatMenuModule,
    MatTooltipModule
  ],
  exports: [
    SelectorChipsComponent
  ]
})
export class SelectorChipsModule { }
